module.exports = __webpack_public_path__ + "img/image10.eec0ec90.png";